/* tslint:disable */
/* eslint-disable */
/**
 * grpc/properties/service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { PropertiesCreateCityRequest } from '../models'
// @ts-ignore
import { PropertiesCreateCityResponse } from '../models'
// @ts-ignore
import { PropertiesCreateDeveloperRequest } from '../models'
// @ts-ignore
import { PropertiesCreateDeveloperResponse } from '../models'
// @ts-ignore
import { PropertiesCreateObjectRequest } from '../models'
// @ts-ignore
import { PropertiesCreateObjectResponse } from '../models'
// @ts-ignore
import { PropertiesCreateResidentialComplexRequest } from '../models'
// @ts-ignore
import { PropertiesCreateResidentialComplexResponse } from '../models'
// @ts-ignore
import { PropertiesDashboardMetricsResponse } from '../models'
// @ts-ignore
import { PropertiesGeneratePresentationResponse } from '../models'
// @ts-ignore
import { PropertiesGetCitiesResponse } from '../models'
// @ts-ignore
import { PropertiesGetLocationPageDataResponse } from '../models'
// @ts-ignore
import { PropertiesGetResidentialComplexFilterValuesResponse } from '../models'
// @ts-ignore
import { PropertiesGetSEODataResponse } from '../models'
// @ts-ignore
import { PropertiesListCitiesAdminResponse } from '../models'
// @ts-ignore
import { PropertiesReadCityAdminResponse } from '../models'
// @ts-ignore
import { PropertiesReadDeveloperAdminResponse } from '../models'
// @ts-ignore
import { PropertiesReadDeveloperResponse } from '../models'
// @ts-ignore
import { PropertiesReadObjectResponse } from '../models'
// @ts-ignore
import { PropertiesReadResidentialComplexAdminResponse } from '../models'
// @ts-ignore
import { PropertiesReadResidentialComplexResponse } from '../models'
// @ts-ignore
import { PropertiesSearchAdminResidentialComplexesResponse } from '../models'
// @ts-ignore
import { PropertiesSearchDevelopersRequest } from '../models'
// @ts-ignore
import { PropertiesSearchDevelopersResponse } from '../models'
// @ts-ignore
import { PropertiesSearchObjectsRequest } from '../models'
// @ts-ignore
import { PropertiesSearchObjectsResponse } from '../models'
// @ts-ignore
import { PropertiesSearchResidentialComplexesRequest } from '../models'
// @ts-ignore
import { PropertiesSearchResidentialComplexesResponse } from '../models'
// @ts-ignore
import { PropertiesServiceUpdateCityBody } from '../models'
// @ts-ignore
import { PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody } from '../models'
// @ts-ignore
import { PropertiesUpdateCityResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateDeveloperRequest } from '../models'
// @ts-ignore
import { PropertiesUpdateDeveloperResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateObjectRequest } from '../models'
// @ts-ignore
import { PropertiesUpdateObjectResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateResidentialComplexAgentsAvailabilityResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateResidentialComplexRequest } from '../models'
// @ts-ignore
import { PropertiesUpdateResidentialComplexResponse } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
/**
 * PropertiesServiceApi - axios parameter creator
 * @export
 */
export const PropertiesServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {PropertiesCreateCityRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateCity: async (
      body: PropertiesCreateCityRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateCity', 'body', body)
      const localVarPath = `/api/v1/properties/admin/cities`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {PropertiesCreateDeveloperRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateDeveloper: async (
      body: PropertiesCreateDeveloperRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateDeveloper', 'body', body)
      const localVarPath = `/api/v1/properties/developer`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {PropertiesCreateObjectRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateObject: async (
      body: PropertiesCreateObjectRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateObject', 'body', body)
      const localVarPath = `/api/v1/properties/object`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {PropertiesCreateResidentialComplexRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateResidentialComplex: async (
      body: PropertiesCreateResidentialComplexRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateResidentialComplex', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complex`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteCity: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteCity', 'id', id)
      const localVarPath = `/api/v1/properties/admin/cities/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteDeveloper: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteDeveloper', 'id', id)
      const localVarPath = `/api/v1/properties/developer/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteObject: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteObject', 'id', id)
      const localVarPath = `/api/v1/properties/object/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteResidentialComplex: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteResidentialComplex', 'id', id)
      const localVarPath = `/api/v1/properties/residential-complex/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Генерация PDF презентации ЖК (защищённый endpoint: admin, hos, manager)
     * @param {string} id ID жилого комплекса
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGeneratePresentation: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceGeneratePresentation', 'id', id)
      const localVarPath = `/api/v1/properties/residential-complex/{id}/presentation`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetCities: async (
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/properties/cities`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetDashboardMetrics: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/properties/dashboard-metrics`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Публичный + SSR: данные страницы города (/locations/:city и intro/outro для /properties/:city).
     * @param {string} citySlug
     * @param {string} [locale]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetLocationPageData: async (
      citySlug: string,
      locale?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'citySlug' is not null or undefined
      assertParamExists('propertiesServiceGetLocationPageData', 'citySlug', citySlug)
      const localVarPath = `/api/v1/properties/locations/{citySlug}`.replace(
        `{${'citySlug'}}`,
        encodeURIComponent(String(citySlug)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (locale !== undefined) {
        localVarQueryParameter['locale'] = locale
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetResidentialComplexFilterValues: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/properties/residential-complex-filter-values`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetSEOData: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/properties/seo-data`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListAllResidentialComplexes: async (
      body: PropertiesSearchResidentialComplexesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceListAllResidentialComplexes', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complexes/all`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ====== CITIES CRUD (Admin) ======
     * @param {boolean} [includeDeleted] Включать ли удалённые города
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListCitiesAdmin: async (
      includeDeleted?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/properties/admin/cities`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeDeleted !== undefined) {
        localVarQueryParameter['includeDeleted'] = includeDeleted
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadCityAdmin: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadCityAdmin', 'id', id)
      const localVarPath = `/api/v1/properties/admin/cities/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadDeveloper: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadDeveloper', 'id', id)
      const localVarPath = `/api/v1/properties/developer/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadDeveloperForAdmin: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadDeveloperForAdmin', 'id', id)
      const localVarPath = `/api/v1/properties/admin/developer/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadObject: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadObject', 'id', id)
      const localVarPath = `/api/v1/properties/object/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplex: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadResidentialComplex', 'id', id)
      const localVarPath = `/api/v1/properties/residential-complex/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} citySlug
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplexBySlug: async (
      citySlug: string,
      slug: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'citySlug' is not null or undefined
      assertParamExists('propertiesServiceReadResidentialComplexBySlug', 'citySlug', citySlug)
      // verify required parameter 'slug' is not null or undefined
      assertParamExists('propertiesServiceReadResidentialComplexBySlug', 'slug', slug)
      const localVarPath = `/api/v1/properties/rc/{citySlug}/{slug}`
        .replace(`{${'citySlug'}}`, encodeURIComponent(String(citySlug)))
        .replace(`{${'slug'}}`, encodeURIComponent(String(slug)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplexForAdmin: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadResidentialComplexForAdmin', 'id', id)
      const localVarPath = `/api/v1/properties/admin/residential-complex/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {PropertiesSearchResidentialComplexesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchAdminResidentialComplexes: async (
      body: PropertiesSearchResidentialComplexesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceSearchAdminResidentialComplexes', 'body', body)
      const localVarPath = `/api/v1/properties/admin/residential-complexes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {PropertiesSearchDevelopersRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchDevelopers: async (
      body: PropertiesSearchDevelopersRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceSearchDevelopers', 'body', body)
      const localVarPath = `/api/v1/properties/developers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {PropertiesSearchObjectsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchObjects: async (
      body: PropertiesSearchObjectsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceSearchObjects', 'body', body)
      const localVarPath = `/api/v1/properties/objects`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchResidentialComplexes: async (
      body: PropertiesSearchResidentialComplexesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceSearchResidentialComplexes', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complexes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {PropertiesServiceUpdateCityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateCity: async (
      id: string,
      body: PropertiesServiceUpdateCityBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceUpdateCity', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateCity', 'body', body)
      const localVarPath = `/api/v1/properties/admin/cities/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {PropertiesUpdateDeveloperRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateDeveloper: async (
      body: PropertiesUpdateDeveloperRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateDeveloper', 'body', body)
      const localVarPath = `/api/v1/properties/developer`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {PropertiesUpdateObjectRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateObject: async (
      body: PropertiesUpdateObjectRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateObject', 'body', body)
      const localVarPath = `/api/v1/properties/object`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {PropertiesUpdateResidentialComplexRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateResidentialComplex: async (
      body: PropertiesUpdateResidentialComplexRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateResidentialComplex', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complex`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DEV-1003: точечно включить/выключить доступность ЖК агентам (permission properties:update).
     * @param {string} id
     * @param {PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateResidentialComplexAgentsAvailability: async (
      id: string,
      body: PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceUpdateResidentialComplexAgentsAvailability', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateResidentialComplexAgentsAvailability', 'body', body)
      const localVarPath =
        `/api/v1/properties/residential-complex/{id}/agents-availability`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PropertiesServiceApi - functional programming interface
 * @export
 */
export const PropertiesServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PropertiesServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {PropertiesCreateCityRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateCity(
      body: PropertiesCreateCityRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesCreateCityResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceCreateCity(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCreateCity']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {PropertiesCreateDeveloperRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateDeveloper(
      body: PropertiesCreateDeveloperRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesCreateDeveloperResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceCreateDeveloper(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCreateDeveloper']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {PropertiesCreateObjectRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateObject(
      body: PropertiesCreateObjectRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesCreateObjectResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceCreateObject(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCreateObject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {PropertiesCreateResidentialComplexRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateResidentialComplex(
      body: PropertiesCreateResidentialComplexRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesCreateResidentialComplexResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceCreateResidentialComplex(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCreateResidentialComplex']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteCity(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceDeleteCity(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDeleteCity']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteDeveloper(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceDeleteDeveloper(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDeleteDeveloper']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteObject(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceDeleteObject(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDeleteObject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteResidentialComplex(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceDeleteResidentialComplex(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDeleteResidentialComplex']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Генерация PDF презентации ЖК (защищённый endpoint: admin, hos, manager)
     * @param {string} id ID жилого комплекса
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGeneratePresentation(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesGeneratePresentationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceGeneratePresentation(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGeneratePresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetCities(
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesGetCitiesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceGetCities(
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGetCities']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetDashboardMetrics(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesDashboardMetricsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceGetDashboardMetrics(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGetDashboardMetrics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Публичный + SSR: данные страницы города (/locations/:city и intro/outro для /properties/:city).
     * @param {string} citySlug
     * @param {string} [locale]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetLocationPageData(
      citySlug: string,
      locale?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesGetLocationPageDataResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceGetLocationPageData(
          citySlug,
          locale,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGetLocationPageData']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetResidentialComplexFilterValues(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesGetResidentialComplexFilterValuesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceGetResidentialComplexFilterValues(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceGetResidentialComplexFilterValues'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetSEOData(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesGetSEODataResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceGetSEOData(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGetSEOData']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceListAllResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesSearchResidentialComplexesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceListAllResidentialComplexes(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceListAllResidentialComplexes']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ====== CITIES CRUD (Admin) ======
     * @param {boolean} [includeDeleted] Включать ли удалённые города
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceListCitiesAdmin(
      includeDeleted?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesListCitiesAdminResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceListCitiesAdmin(
        includeDeleted,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceListCitiesAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadCityAdmin(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesReadCityAdminResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceReadCityAdmin(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadCityAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadDeveloper(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesReadDeveloperResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceReadDeveloper(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadDeveloper']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadDeveloperForAdmin(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesReadDeveloperAdminResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceReadDeveloperForAdmin(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadDeveloperForAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadObject(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesReadObjectResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceReadObject(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadObject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadResidentialComplex(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesReadResidentialComplexResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceReadResidentialComplex(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadResidentialComplex']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} citySlug
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadResidentialComplexBySlug(
      citySlug: string,
      slug: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesReadResidentialComplexResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceReadResidentialComplexBySlug(
          citySlug,
          slug,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadResidentialComplexBySlug']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadResidentialComplexForAdmin(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesReadResidentialComplexAdminResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceReadResidentialComplexForAdmin(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceReadResidentialComplexForAdmin'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {PropertiesSearchResidentialComplexesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceSearchAdminResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesSearchAdminResidentialComplexesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceSearchAdminResidentialComplexes(
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceSearchAdminResidentialComplexes'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {PropertiesSearchDevelopersRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceSearchDevelopers(
      body: PropertiesSearchDevelopersRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesSearchDevelopersResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceSearchDevelopers(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceSearchDevelopers']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {PropertiesSearchObjectsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceSearchObjects(
      body: PropertiesSearchObjectsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesSearchObjectsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceSearchObjects(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceSearchObjects']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceSearchResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesSearchResidentialComplexesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceSearchResidentialComplexes(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceSearchResidentialComplexes']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {PropertiesServiceUpdateCityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateCity(
      id: string,
      body: PropertiesServiceUpdateCityBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesUpdateCityResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceUpdateCity(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceUpdateCity']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {PropertiesUpdateDeveloperRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateDeveloper(
      body: PropertiesUpdateDeveloperRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesUpdateDeveloperResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceUpdateDeveloper(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceUpdateDeveloper']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {PropertiesUpdateObjectRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateObject(
      body: PropertiesUpdateObjectRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesUpdateObjectResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceUpdateObject(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceUpdateObject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {PropertiesUpdateResidentialComplexRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateResidentialComplex(
      body: PropertiesUpdateResidentialComplexRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesUpdateResidentialComplexResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceUpdateResidentialComplex(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceUpdateResidentialComplex']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DEV-1003: точечно включить/выключить доступность ЖК агентам (permission properties:update).
     * @param {string} id
     * @param {PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateResidentialComplexAgentsAvailability(
      id: string,
      body: PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesUpdateResidentialComplexAgentsAvailabilityResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceUpdateResidentialComplexAgentsAvailability(
          id,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceUpdateResidentialComplexAgentsAvailability'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PropertiesServiceApi - factory interface
 * @export
 */
export const PropertiesServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PropertiesServiceApiFp(configuration)
  return {
    /**
     *
     * @param {PropertiesCreateCityRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateCity(
      body: PropertiesCreateCityRequest,
      options?: any,
    ): AxiosPromise<PropertiesCreateCityResponse> {
      return localVarFp
        .propertiesServiceCreateCity(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {PropertiesCreateDeveloperRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateDeveloper(
      body: PropertiesCreateDeveloperRequest,
      options?: any,
    ): AxiosPromise<PropertiesCreateDeveloperResponse> {
      return localVarFp
        .propertiesServiceCreateDeveloper(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {PropertiesCreateObjectRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateObject(
      body: PropertiesCreateObjectRequest,
      options?: any,
    ): AxiosPromise<PropertiesCreateObjectResponse> {
      return localVarFp
        .propertiesServiceCreateObject(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {PropertiesCreateResidentialComplexRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateResidentialComplex(
      body: PropertiesCreateResidentialComplexRequest,
      options?: any,
    ): AxiosPromise<PropertiesCreateResidentialComplexResponse> {
      return localVarFp
        .propertiesServiceCreateResidentialComplex(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteCity(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteCity(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteDeveloper(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteDeveloper(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteObject(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteObject(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteResidentialComplex(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteResidentialComplex(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Генерация PDF презентации ЖК (защищённый endpoint: admin, hos, manager)
     * @param {string} id ID жилого комплекса
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGeneratePresentation(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesGeneratePresentationResponse> {
      return localVarFp
        .propertiesServiceGeneratePresentation(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetCities(
      paginationPage?: string,
      paginationPerPage?: string,
      options?: any,
    ): AxiosPromise<PropertiesGetCitiesResponse> {
      return localVarFp
        .propertiesServiceGetCities(paginationPage, paginationPerPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetDashboardMetrics(
      options?: any,
    ): AxiosPromise<PropertiesDashboardMetricsResponse> {
      return localVarFp
        .propertiesServiceGetDashboardMetrics(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Публичный + SSR: данные страницы города (/locations/:city и intro/outro для /properties/:city).
     * @param {string} citySlug
     * @param {string} [locale]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetLocationPageData(
      citySlug: string,
      locale?: string,
      options?: any,
    ): AxiosPromise<PropertiesGetLocationPageDataResponse> {
      return localVarFp
        .propertiesServiceGetLocationPageData(citySlug, locale, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetResidentialComplexFilterValues(
      options?: any,
    ): AxiosPromise<PropertiesGetResidentialComplexFilterValuesResponse> {
      return localVarFp
        .propertiesServiceGetResidentialComplexFilterValues(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetSEOData(options?: any): AxiosPromise<PropertiesGetSEODataResponse> {
      return localVarFp
        .propertiesServiceGetSEOData(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListAllResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: any,
    ): AxiosPromise<PropertiesSearchResidentialComplexesResponse> {
      return localVarFp
        .propertiesServiceListAllResidentialComplexes(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ====== CITIES CRUD (Admin) ======
     * @param {boolean} [includeDeleted] Включать ли удалённые города
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListCitiesAdmin(
      includeDeleted?: boolean,
      options?: any,
    ): AxiosPromise<PropertiesListCitiesAdminResponse> {
      return localVarFp
        .propertiesServiceListCitiesAdmin(includeDeleted, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadCityAdmin(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadCityAdminResponse> {
      return localVarFp
        .propertiesServiceReadCityAdmin(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadDeveloper(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadDeveloperResponse> {
      return localVarFp
        .propertiesServiceReadDeveloper(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadDeveloperForAdmin(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadDeveloperAdminResponse> {
      return localVarFp
        .propertiesServiceReadDeveloperForAdmin(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadObject(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadObjectResponse> {
      return localVarFp
        .propertiesServiceReadObject(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplex(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadResidentialComplexResponse> {
      return localVarFp
        .propertiesServiceReadResidentialComplex(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} citySlug
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplexBySlug(
      citySlug: string,
      slug: string,
      options?: any,
    ): AxiosPromise<PropertiesReadResidentialComplexResponse> {
      return localVarFp
        .propertiesServiceReadResidentialComplexBySlug(citySlug, slug, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplexForAdmin(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadResidentialComplexAdminResponse> {
      return localVarFp
        .propertiesServiceReadResidentialComplexForAdmin(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {PropertiesSearchResidentialComplexesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchAdminResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: any,
    ): AxiosPromise<PropertiesSearchAdminResidentialComplexesResponse> {
      return localVarFp
        .propertiesServiceSearchAdminResidentialComplexes(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {PropertiesSearchDevelopersRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchDevelopers(
      body: PropertiesSearchDevelopersRequest,
      options?: any,
    ): AxiosPromise<PropertiesSearchDevelopersResponse> {
      return localVarFp
        .propertiesServiceSearchDevelopers(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {PropertiesSearchObjectsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchObjects(
      body: PropertiesSearchObjectsRequest,
      options?: any,
    ): AxiosPromise<PropertiesSearchObjectsResponse> {
      return localVarFp
        .propertiesServiceSearchObjects(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: any,
    ): AxiosPromise<PropertiesSearchResidentialComplexesResponse> {
      return localVarFp
        .propertiesServiceSearchResidentialComplexes(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {PropertiesServiceUpdateCityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateCity(
      id: string,
      body: PropertiesServiceUpdateCityBody,
      options?: any,
    ): AxiosPromise<PropertiesUpdateCityResponse> {
      return localVarFp
        .propertiesServiceUpdateCity(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {PropertiesUpdateDeveloperRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateDeveloper(
      body: PropertiesUpdateDeveloperRequest,
      options?: any,
    ): AxiosPromise<PropertiesUpdateDeveloperResponse> {
      return localVarFp
        .propertiesServiceUpdateDeveloper(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {PropertiesUpdateObjectRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateObject(
      body: PropertiesUpdateObjectRequest,
      options?: any,
    ): AxiosPromise<PropertiesUpdateObjectResponse> {
      return localVarFp
        .propertiesServiceUpdateObject(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {PropertiesUpdateResidentialComplexRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateResidentialComplex(
      body: PropertiesUpdateResidentialComplexRequest,
      options?: any,
    ): AxiosPromise<PropertiesUpdateResidentialComplexResponse> {
      return localVarFp
        .propertiesServiceUpdateResidentialComplex(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DEV-1003: точечно включить/выключить доступность ЖК агентам (permission properties:update).
     * @param {string} id
     * @param {PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateResidentialComplexAgentsAvailability(
      id: string,
      body: PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody,
      options?: any,
    ): AxiosPromise<PropertiesUpdateResidentialComplexAgentsAvailabilityResponse> {
      return localVarFp
        .propertiesServiceUpdateResidentialComplexAgentsAvailability(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * PropertiesServiceApi - object-oriented interface
 * @export
 * @class PropertiesServiceApi
 * @extends {BaseAPI}
 */
export class PropertiesServiceApi extends BaseAPI {
  /**
   *
   * @param {PropertiesCreateCityRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateCity(
    body: PropertiesCreateCityRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateCity(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {PropertiesCreateDeveloperRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateDeveloper(
    body: PropertiesCreateDeveloperRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateDeveloper(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {PropertiesCreateObjectRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateObject(
    body: PropertiesCreateObjectRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateObject(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {PropertiesCreateResidentialComplexRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateResidentialComplex(
    body: PropertiesCreateResidentialComplexRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateResidentialComplex(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteCity(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteCity(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteDeveloper(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteDeveloper(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteObject(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteObject(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteResidentialComplex(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteResidentialComplex(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Генерация PDF презентации ЖК (защищённый endpoint: admin, hos, manager)
   * @param {string} id ID жилого комплекса
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGeneratePresentation(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGeneratePresentation(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
   * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetCities(
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetCities(paginationPage, paginationPerPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetDashboardMetrics(options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetDashboardMetrics(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Публичный + SSR: данные страницы города (/locations/:city и intro/outro для /properties/:city).
   * @param {string} citySlug
   * @param {string} [locale]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetLocationPageData(
    citySlug: string,
    locale?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetLocationPageData(citySlug, locale, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetResidentialComplexFilterValues(options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetResidentialComplexFilterValues(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetSEOData(options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetSEOData(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   * @param {PropertiesSearchResidentialComplexesRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceListAllResidentialComplexes(
    body: PropertiesSearchResidentialComplexesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceListAllResidentialComplexes(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ====== CITIES CRUD (Admin) ======
   * @param {boolean} [includeDeleted] Включать ли удалённые города
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceListCitiesAdmin(
    includeDeleted?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceListCitiesAdmin(includeDeleted, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadCityAdmin(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadCityAdmin(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadDeveloper(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadDeveloper(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadDeveloperForAdmin(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadDeveloperForAdmin(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadObject(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadObject(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadResidentialComplex(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadResidentialComplex(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} citySlug
   * @param {string} slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadResidentialComplexBySlug(
    citySlug: string,
    slug: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadResidentialComplexBySlug(citySlug, slug, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadResidentialComplexForAdmin(
    id: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadResidentialComplexForAdmin(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {PropertiesSearchResidentialComplexesRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceSearchAdminResidentialComplexes(
    body: PropertiesSearchResidentialComplexesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceSearchAdminResidentialComplexes(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {PropertiesSearchDevelopersRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceSearchDevelopers(
    body: PropertiesSearchDevelopersRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceSearchDevelopers(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {PropertiesSearchObjectsRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceSearchObjects(
    body: PropertiesSearchObjectsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceSearchObjects(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   * @param {PropertiesSearchResidentialComplexesRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceSearchResidentialComplexes(
    body: PropertiesSearchResidentialComplexesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceSearchResidentialComplexes(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {PropertiesServiceUpdateCityBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateCity(
    id: string,
    body: PropertiesServiceUpdateCityBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateCity(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {PropertiesUpdateDeveloperRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateDeveloper(
    body: PropertiesUpdateDeveloperRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateDeveloper(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {PropertiesUpdateObjectRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateObject(
    body: PropertiesUpdateObjectRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateObject(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {PropertiesUpdateResidentialComplexRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateResidentialComplex(
    body: PropertiesUpdateResidentialComplexRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateResidentialComplex(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DEV-1003: точечно включить/выключить доступность ЖК агентам (permission properties:update).
   * @param {string} id
   * @param {PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateResidentialComplexAgentsAvailability(
    id: string,
    body: PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateResidentialComplexAgentsAvailability(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
